import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.LicenseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about licenses
 * using http requests.
 */
export default class LicenseRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.LicenseRestService#getAllAsync
     * @methodOf rest.services.LicenseRestService
     * @function
     *
     * @description
     * Retrieves licenses.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('licenses/');

    }

    /**
     * @ngdoc function
     * @name rest.services.LicenseRestService#create
     * @methodOf rest.services.LicenseRestService
     * @function
     *
     * @description
     * Create a license.
     *
     * @param {object} licensePayload payload
     *
     * @returns {Promise} The promise of the call.
     */
    create(licensePayload) {

        return super.create(licensePayload, 'licenses/');

    }

}

_serviceDependencies.push(LicenseRestService);

angular.module('rest.services')
    .service('LicenseRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/licenseRestService.js